import './styles/index.scss'
import Gl from './modules/Gl'

const gl = new Gl(document.querySelector('canvas.gl'))
